import apiClient from './api.service';
import type {
  ContractorUserEntry,
  CreateInvitationRequest,
  InvitationData,
  InvitationInfo,
  AcceptInvitationResponse,
} from '../types/contractor-invitation.types';

export async function listContractorUsers(contractorId: string): Promise<ContractorUserEntry[]> {
  const { data } = await apiClient.get(`/api/admin/contractors/${contractorId}/users`);
  return data.data.entries;
}

export async function createInvitation(
  contractorId: string,
  payload: CreateInvitationRequest
): Promise<InvitationData> {
  const { data } = await apiClient.post(
    `/api/admin/contractors/${contractorId}/invitations`,
    payload
  );
  return data.data.invitation;
}

export async function resendInvitation(
  contractorId: string,
  invitationId: string
): Promise<InvitationData> {
  const { data } = await apiClient.post(
    `/api/admin/contractors/${contractorId}/invitations/${invitationId}/resend`
  );
  return data.data.invitation;
}

export async function dissociateUser(contractorId: string, userId: string): Promise<void> {
  await apiClient.delete(`/api/admin/contractors/${contractorId}/users/${userId}`);
}

export async function getInvitationInfo(hash: string): Promise<InvitationInfo> {
  const { data } = await apiClient.get(`/api/contractor-invitations/${hash}`);
  return data.data;
}

export async function acceptInvitation(hash: string): Promise<AcceptInvitationResponse> {
  const { data } = await apiClient.post(`/api/contractor-invitations/${hash}/accept`);
  return data.data;
}
